import React from 'react'

function Contact() {
    return (
        <div>
            contact us page
        </div>
    )
}

export default Contact
